import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from './Lightbox';

const galleryImages = [
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/0cfd0634-8657-49a2-981e-83f65dc3d2b1_compressed_Captura-de-pantalla-2026-07-16-a-las-14.18.56.webp',
    alt: 'Villa Buenlugar - Private pool terrace with palm trees and sun loungers',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/c0f865ac-009b-4974-b6cc-bf4b87855c06_compressed_Captura-de-pantalla-2026-07-16-a-las-14.20.25.webp',
    alt: 'Villa Buenlugar - Entrance with Villa Buenlugar 19 sign and wooden gate',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/423c8bfc-4664-471b-b62a-1004ce89c013_compressed_Captura-de-pantalla-2026-07-16-a-las-14.20.17.webp',
    alt: 'Villa Buenlugar - Exterior white walls with stone accents and wooden doors',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/13ef1ebb-c906-43b9-a8e5-a58cb48f082c_compressed_Captura-de-pantalla-2026-07-16-a-las-14.19.13.webp',
    alt: 'Villa Buenlugar - Living and dining room with wooden furniture and TV',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/ead6868a-fd7a-4b00-87a4-43cef72bab00_compressed_Captura-de-pantalla-2026-07-16-a-las-14.19.38.webp',
    alt: 'Villa Buenlugar - Fully equipped kitchen with cream cabinets and appliances',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/b726fcb2-afaa-4823-8693-ec9068eb3831_compressed_Captura-de-pantalla-2026-07-16-a-las-14.18.42.webp',
    alt: 'Villa Buenlugar - Master bedroom with carved wooden bed frame and beach paintings',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/3e67d834-085b-4793-bcd8-27b64a9694c9_compressed_Captura-de-pantalla-2026-07-16-a-las-14.19.23.webp',
    alt: 'Villa Buenlugar - Master bedroom with French doors opening to the terrace',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/f87347ab-1a90-459a-b8c4-c0fabf17d8c6_compressed_Captura-de-pantalla-2026-07-16-a-las-14.20.00.webp',
    alt: 'Villa Buenlugar - Second bedroom with two single beds and red dresser',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/7b22f8b4-f565-4dd9-b59c-3d07dfe70469_compressed_Captura-de-pantalla-2026-07-16-a-las-14.18.31.webp',
    alt: 'Villa Buenlugar - Bathroom with terracotta tiles, wooden vanity and bathtub',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/e96febd6-6959-486d-882a-6b2e345b9034_compressed_Captura-de-pantalla-2026-07-16-a-las-14.20.09.webp',
    alt: 'Villa Buenlugar - Second bathroom with white and blue tile and glass shower',
  },
];

export default function BuenlugarGallery() {
  const { t } = useTranslation();
  const [lightboxIndex, setLightboxIndex] = useState<number>(-1);

  const handlePrev = () => {
    setLightboxIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
  };

  const handleNext = () => {
    setLightboxIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
  };

  return (
    <section id="gallery" className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">
            {t('gallery_subtitle')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">
            {t('gallery_title')}
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="break-inside-avoid mb-4 md:mb-5 rounded-lg overflow-hidden cursor-pointer group relative"
              onClick={() => setLightboxIndex(i)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                <span className="w-10 h-10 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform scale-75 group-hover:scale-100">
                  <i className="ri-zoom-in-line text-xl"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxIndex >= 0 && (
        <Lightbox
          images={galleryImages}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(-1)}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      )}
    </section>
  );
}